import { useState } from "react";
import { RiAddLine, RiSubtractLine } from "react-icons/ri";

const faqData = [
  {
    question:
      "1) What makes SWITCH different from existing marketplaces or payment platforms?",
    answer: `SWITCH transforms every transaction into programmable trust. 
    Instead of ending at payment, each completed trade generates reputation data that unlocks tangible benefits such as higher selling limits, community access, and DAO eligibility. 
    Users build portable, user-owned trust that grows with every interaction.`,
  },
  {
    question:
      "2) How are transactions protected? How does the on-chain escrow work?",
    answer: `Funds are locked in a smart-contract escrow the moment a buyer confirms a purchase. Settlement only occurs after both sides confirm completion.
• No platform custody
• Immutable on-chain record
• Minimal fraud and dispute risk
SWITCH provides trustless, low-cost protection without relying on centralized intermediaries.`,
  },
  {
    question: "3) What is a Reputation SBT, and why is it important?",
    answer: `A Reputation SBT (Soulbound Token) is a non-transferable trust badge minted after verified behavior. It cannot be altered, traded, or removed—users permanently own it. Reputation SBTs unlock meaningful advantages:
• Increased selling limits
• Access to high-trust communities
• Eligibility for local DAOs
• Priority in future reward programs
It is the foundation of SWITCH’s trust-driven economic model.`,
  },
  {
    question: "4) How is the SWITCH Coin (SWC) used inside the ecosystem?",
    answer: `SWC acts as a functional utility token that powers the protocol. It is used for:
• Transaction signaling
• Smart contract execution fees
• Access to premium features
• Participation in DAO governance
Some services also integrate USDT settlement, ensuring stable payouts for merchants and frictionless UX for users.`,
  },
  {
    question: "5) Where can SWITCH be used today?",
    answer: `SWITCH is designed for real-world commerce and can already be applied to:
• Console & game marketplaces
• Used-car rentals and local mobility services
• Webtoon episode payments
• Franchise and offline merchant payments
All use cases share the same principle:Every transaction becomes trust. Every trust unlocks new economic value.`,
  },
];

export default function Section7() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleItem = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="relative z-10 w-full flex flex-col items-center justify-center mb-[80px] md:mb-[130px] lg:mb-[150px]">
      <div className="container mx-auto px-4">
        <h2 className="text-[48px] font-normal text-white tracking-tight mb-[80px] md:mb-[130px] lg:mb-[150px] text-center">
          Frequently asked questions
        </h2>
        <div className="flex flex-col">
          {faqData.map((item, index) => (
            <div key={index} className="border-b border-white">
              <button
                onClick={() => toggleItem(index)}
                className="w-full flex items-center justify-between py-4 text-white hover:opacity-80 transition-opacity"
              >
                <span className="text-left text-[20px] font-normal leading-10 text-white tracking-tight">
                  {item.question}
                </span>
                {openIndex === index ? (
                  <RiSubtractLine className="text-xl" />
                ) : (
                  <RiAddLine className="text-xl" />
                )}
              </button>
              {openIndex === index && (
                <div className="pb-4 text-white whitespace-pre-line text-[16px]">
                  {item.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
